var _a;
import { optionsMap } from 'pro-gallery-lib';
import { PLACEMENT_TO_TEXT_POSITION_MAP, PLACEMENT_TO_FLEX_MAP } from "../consts";
export var INFO = {
    WIDTH_IN_PIXEL: "controllers_" + optionsMap.layoutParams.info.width + "_pixel",
    WIDTH_IN_PERCENT: "controllers_" + optionsMap.layoutParams.info.width + "_percent",
    VERTICAL_ALIGN: "controllers_layoutParams_info_verticalAlignment",
    HORIZONTAL_ALIGN: "controllers_layoutParams_info_horizontalAlignment",
    VERTICAL_PADDING: "controllers_layoutParams_info_verticalPadding",
    HORIZONTAL_PADDING: "controllers_layoutParams_info_horizontalPadding",
    ALLOW_TITLE: "controllers_layoutParams_info_allowTitle",
    ALLOW_DESCRIPTION: "controllers_layoutParams_info_allowDescription",
};
export var INFO_CONTROLLERS = (_a = {},
    _a[INFO.WIDTH_IN_PIXEL] = function (value, options) {
        var _a;
        var unitSize = options[optionsMap.layoutParams.info.sizeUnits];
        if (unitSize !== 'PIXEL' || value === undefined) {
            return;
        }
        return _a = {},
            _a[optionsMap.layoutParams.info.width] = value,
            _a;
    },
    _a[INFO.WIDTH_IN_PERCENT] = function (value, options) {
        var _a;
        var unitSize = options[optionsMap.layoutParams.info.sizeUnits];
        if (unitSize !== 'PERCENT' || value === undefined) {
            return;
        }
        return _a = {}, _a[optionsMap.layoutParams.info.width] = value, _a;
    },
    _a[INFO.ALLOW_TITLE] = 'allowTitle',
    _a[INFO.ALLOW_DESCRIPTION] = 'allowDescription',
    _a[INFO.VERTICAL_ALIGN] = 'galleryVerticalAlign',
    _a[INFO.HORIZONTAL_ALIGN] = function (value, _options) {
        if (value === undefined) {
            return;
        }
        return {
            galleryHorizontalAlign: PLACEMENT_TO_FLEX_MAP[value],
            galleryTextAlign: PLACEMENT_TO_TEXT_POSITION_MAP[value],
        };
    },
    _a[INFO.VERTICAL_PADDING] = 'textsVerticalPadding',
    _a[INFO.HORIZONTAL_PADDING] = 'textsHorizontalPadding',
    _a);
//# sourceMappingURL=info.js.map